import { IFromLibrarySettings } from 'core-components/sitebuilder/models/IWidget'

export const getProperty = (properties: IFromLibrarySettings['properties'], name: string) => {
  return properties?.find((el) => el.name === name)
}
